import React from 'react';

export default function SaversFooter(){
    return (
        <footer className="main-footer text-center text-md-right">
        &copy; {(new Date()).getFullYear()} <a href="https://asinso.com" className='text-muted'>Asinso Savers.</a>
        </footer>
    )
}
